import { TinKernHeader, useSectionDeepLink } from '@tinkern/layout'
import { TinKernLogo } from '@tinkern/ui'
import StickyNav from './components/StickyNav'
import MusicSection from './sections/MusicSection'
import FoodSection from './sections/FoodSection'
import ReadingSection from './sections/ReadingSection'
import PhotosSection from './sections/PhotosSection'
import SignalLogSection from './sections/SignalLogSection'

const LIFE_SECTION_IDS = ['music', 'food', 'reading', 'photos', 'signal-log'] as const

export default function App() {
  useSectionDeepLink(LIFE_SECTION_IDS)

  return (
    <div className="min-h-screen text-amber-50">
      <TinKernHeader
        active="after-hours"
        brand={
          <a
            href="https://life.tinkernlabs.com"
            className="inline-flex items-center gap-3 group"
          >
            <TinKernLogo size="sm" variant="mono" className="ring-1 ring-amber-400/30 group-hover:ring-amber-400/60 transition-all" />
            <span className="text-base font-heading font-semibold tracking-wide text-amber-100 group-hover:text-amber-300 transition-colors hidden sm:inline">
              After Hours
            </span>
          </a>
        }
        containerClassName="sticky top-0 z-40 backdrop-blur-md bg-navy-900/80 border-b border-amber-400/15"
        manifestProps={{
          triggerClassName:
            'inline-flex items-center gap-1 px-3 py-2 rounded-lg text-sm text-amber-100/80 hover:text-amber-100 border border-amber-400/20 hover:border-amber-400/40 transition-colors',
          panelClassName:
            'absolute right-0 mt-2 w-72 rounded-xl border border-amber-400/20 bg-navy-900/95 backdrop-blur-md shadow-2xl p-2 z-50',
          itemClassName: 'block px-3 py-2 rounded-lg hover:bg-amber-400/10 transition-colors',
          activeItemClassName: 'bg-amber-400/10',
          labelClassName: 'text-sm font-medium text-amber-100',
          descriptionClassName: 'text-xs text-amber-200/60 mt-0.5',
        }}
      />

      <StickyNav />

      <main id="main-content" className="max-w-6xl mx-auto px-4 sm:px-6">
        <section className="pt-20 pb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-amber-300/70 mb-3">
            life.tinkernlabs.com
          </p>
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-heading font-medium amber-gradient-text leading-tight">
            After Hours.
          </h1>
          <p className="mt-6 text-lg text-amber-100/70 max-w-2xl leading-relaxed">
            The human side beneath the systems. Not productivity. Not influence. Just the inputs —
            music in the ears, food on the plate, books on the desk, frames in the camera, and
            whatever's on the mind right now.
          </p>
        </section>

        <MusicSection />
        <FoodSection />
        <ReadingSection />
        <PhotosSection />
        <SignalLogSection />
      </main>

      <footer className="border-t border-amber-400/15 mt-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 text-sm text-amber-200/60 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <p>© 2026 Venkata Keerthan Nimmala — After Hours, TinKern Labs.</p>
          <p className="font-heading italic">Same person, different mood.</p>
        </div>
      </footer>
    </div>
  )
}
